import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogProps,
	DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface ConfirmDialogProps extends DialogProps {
	title: string;
	content: string;
	actionOk: () => void;
	actionCancel?: () => void;
}

export default function ConfirmDialog(props: ConfirmDialogProps) {
	const handleOk = () => {
		props.actionOk && props.actionOk();
	};
	const handleCancel = () => {
		props.actionCancel && props.actionCancel();
	};
	const { t } = useTranslation();

	return (
		<Dialog onClose={props.onClose} open={props.open}>
			<DialogTitle>{props.title}</DialogTitle>
			<DialogContent>
				<DialogContentText id='alert-dialog-description'>
					{props.content}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant='contained' onClick={handleOk} autoFocus>
					{t("confirm")}
				</Button>
				<Button variant='contained' color='warning' onClick={handleCancel}>
					{t("cancel")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
